export default __webpack_public_path__ + "static/media/ic_text-underline.115b10f1.svg";